import { useState } from 'react'
import { Modal, Input, Button, Alert } from 'antd'
import { CopyOutlined, CheckOutlined } from '@ant-design/icons'
import { showMessageError, showMessageSuccess } from 'src/helpers/functions'
import { copyToClipboard } from './copyToClipboard'

/**
 * Modal hien thi key vua tao. Admin van xem/copy lai duoc key nay
 * bat cu luc nao o cot "Ma key" trong bang danh sach.
 */
const ShowKey = (props: any) => {
   const { visible, apiKey, onClose } = props
   const [copied, setCopied] = useState(false)

   const handleCopy = async () => {
      const ok = await copyToClipboard(apiKey)
      if (ok) {
         setCopied(true)
         showMessageSuccess('Đã sao chép API key')
         setTimeout(() => setCopied(false), 2000)
      } else {
         showMessageError('Không sao chép được, vui lòng bôi đen và copy thủ công')
      }
   }

   return (
      <Modal
         width={'68%'}
         visible={visible}
         centered
         title={'API key đã được tạo'}
         onCancel={onClose}
         maskClosable={false}
         footer={[
            <Button key="close" type="primary" onClick={onClose}>
               {'Đóng'}
            </Button>
         ]}
      >
         <Alert
            type="info"
            showIcon
            message={'Đã tạo key thành công'}
            description={
               'Bạn có thể xem lại và sao chép key này bất cứ lúc nào ở cột "Mã key" trong danh sách. Hãy gửi key cho đúng người và thu hồi ngay nếu nghi ngờ bị lộ.'
            }
            style={{ marginBottom: 16 }}
         />

         <Input.TextArea value={apiKey} readOnly autoSize={{ minRows: 2, maxRows: 4 }} onFocus={(e) => e.target.select()} />

         <div style={{ marginTop: 16, textAlign: 'right' }}>
            <Button type="primary" icon={copied ? <CheckOutlined /> : <CopyOutlined />} onClick={handleCopy}>
               {copied ? 'Đã sao chép' : 'Sao chép key'}
            </Button>
         </div>

         <div style={{ marginTop: 16 }}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>{'Cách sử dụng'}</div>
            <div style={{ marginBottom: 4 }}>
               {'Gửi key qua header '}
               <b>x-key</b>
               {' thay cho access token:'}
            </div>
            <Input.TextArea
               readOnly
               autoSize={{ minRows: 2, maxRows: 4 }}
               value={`curl -H "x-key: ${apiKey}" ${window.location.origin.replace(/\/$/, '')}/v1/job`}
            />
         </div>
      </Modal>
   )
}

export default ShowKey
